/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTemplateChat } from '../../models/api-response-template-chat';
import { TemplateChat } from '../../models/template-chat';

export interface UpdateTemplate$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: TemplateChat
}

export function updateTemplate(http: HttpClient, rootUrl: string, params: UpdateTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateChat>> {
  const rb = new RequestBuilder(rootUrl, updateTemplate.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTemplateChat>;
    })
  );
}

updateTemplate.PATH = '/v1/api/ui/templates-chat/{reference}';
